<script lang="ts">
  // components
  import TwoColumnRow from './TwoColumnRow.svelte';

  // utils
  import { getSeatNumber, orderedChoices } from '../utils/race-helpers.js';

  // types
  import type { Readable } from 'svelte/store';
  import type { Race } from '../types';

  /** A readable Svelte store of the races for one office (from mountLegislature) */
  export let races: Readable<Race[]>;

  $: racesStore = $races;
</script>

<table class="summary-results">
  <thead class="sticky-top">
    <tr>
      <th scope="col" class="text-center text-uppercase">District</th>
      <th colSpan={2} scope="col" class="text-uppercase">Candidates</th>
      <th scope="col" class="text-right text-uppercase">
        % In<span class="invisible"></span>
      </th>
    </tr>
  </thead>
  <tbody>
    {#each racesStore as r}
    {#if getSeatNumber(r) != 0}
        <TwoColumnRow
        candidates = {orderedChoices(r)}
        districtNumber={getSeatNumber(r)}
        isUncontested={r.attributes.isUncontested ?? false}
        eevp={r.attributes.eevp ?? 0}
        totalVotes={r.attributes.totalVotes}
        />
    {/if}
    {/each}
  </tbody>
</table>
